import { hooks } from '@yola/ws-sdk';
import hide from './hide';
import hideAnchors from './hide-anchors';

const hideOnLiveDocumentConnected = () => {
  hooks.operations.subscribe(hooks.availableHooks.ON_LIVE_DOCUMENT_CONNECTED, () => {
    hide();
    hideAnchors();
  });
};

export default hideOnLiveDocumentConnected;
